import { checkTagInJsonQuery } from './checkTagInJsonQuery';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { ITag } from '../../types/tags';

/**
 * Фильтрует массив тегов по jsonQuery
 * @param {ITag[]} tags - массив тегов
 * @param {IJsonQuery} jsonQuery - эталонный jsonQuery
 * @returns {ITag[]}
 */
export const filterTagsByJsonQuery = (tags: ITag[], jsonQuery: IJsonQuery): ITag[] => {
  return tags.filter(tag => checkTagInJsonQuery(tag, jsonQuery));
};
